@import "~swiper/swiper";

:host,
:root {
  /**
   * @prop --c-swiper-background-color: Swiper background color
   * @prop --c-swiper-hover-color: Swiper hover color
   * @prop --c-swiper-text-color: Swiper text color
   * @prop --c-swiper-active-background-color: Swiper active background color
   * @prop --c-swiper-active-text-color: Swiper active text color
   * @prop --c-swiper-disabled-background-color: Swiper disabled background color
   * @prop --c-swiper-disabled-text-color: Swiper disabled text color
   */
  --c-swiper-background-color: var(--c-primary-200);
  --c-swiper-hover-color: var(--c-primary-100);
  --c-swiper-text-color: var(--c-primary-600);
  --c-swiper-active-background-color: var(--c-primary-600);
  --c-swiper-active-text-color: var(--c-white);
  --c-swiper-disabled-background-color: var(--c-tertiary-100);
  --c-swiper-disabled-text-color: var(--c-tertiary-600);
}

.c-swiper {
  &__navigation {
    display: grid;
    gap: 8px;
    grid-template-columns: auto auto 1fr;
    align-items: center;
    margin-top: 8px;
    padding: 4px;
  }

  .swiper-wrapper {
    width: 1px !important;
    display: grid !important;
    grid-auto-flow: column;
    grid-template-columns: 1fr;
  }

  .swiper-pagination {
    position: relative;
    bottom: auto;
    left: auto;
    width: auto;
    text-align: right;
  }

  .swiper-container {
    overflow: hidden;
  }

  .c-icon-button {
    &--next,
    &--prev {
      z-index: 1;
      position: relative;
    }
  }

  .visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}
